export type AdminRole = 'owner' | 'admin' | 'support'
export type AdminStatus = 'active' | 'disabled'

export interface AdminProfile {
  id: string
  phone: string
  firstName: string
  lastName: string
  name: string
  role: AdminRole
  status: AdminStatus
  lastLoginAt?: string | null
  createdAt?: string | null
  updatedAt?: string | null
}

export interface AdminListPage<T> {
  items: T[]
  total: number
  page: number
  limit: number
}

export const ADMIN_ROLE_LABELS: Record<AdminRole, string> = {
  owner: 'مالک سیستم',
  admin: 'مدیر',
  support: 'پشتیبان',
}

export function staffHomePath(role: string | null | undefined): string {
  return role === 'support' ? '/support' : '/admin'
}
